import { render, staticRenderFns } from "./ProductOverviewPanel.vue?vue&type=template&id=2e7bc5a0&scoped=true"
import script from "./ProductOverviewPanel.vue?vue&type=script&lang=ts"
export * from "./ProductOverviewPanel.vue?vue&type=script&lang=ts"
import style0 from "./ProductOverviewPanel.vue?vue&type=style&index=0&id=2e7bc5a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7bc5a0",
  null
  
)

export default component.exports